



export const setStorage = (key,jsonObj) => {
    sessionStorage.setItem(key, JSON.stringify(jsonObj));
}

export const getStorage = (keyName) => {
    const item= sessionStorage.getItem(keyName);
    return JSON.parse(item);
}

export const removeStorage = (keyName) => {
    sessionStorage.removeItem(keyName);
}
export const getAuthHeader = () => {
    const token = getStorage('token');
    const header = {
        headers: { Authorization: "Bearer " + token }
    };
    return header;
}

export const getUploadFileHeader = () => {
    const token = getStorage('token');
    const header = {
        headers: {
            Authorization: "Bearer " + token,
            'content-type': 'multipart/form-data/json'
        }
    };
    return header;
}


export const setError = (context,name,error,callback) => {
    context.setState({ [name]: { ...context.state[name], error } }, callback && callback);
}

export const setRequired = (context, name, newIsRequired, callback) => {
    context.setState({ [name]: { ...context.state[name], isRequired: newIsRequired } }, callback && callback);
}
export const validateForm = (context) => {
    const st = JSON.parse(JSON.stringify(context));
    let status = true;
    for (let key in st) {
        if (st.hasOwnProperty(key) && st[key]) {
            const name = st[key].name;
            const isRequired = st[key].isRequired;
            const value = st[key].value;
            if (isRequired && (value === null || value === undefined || value.length === 0)) {
                status = false;
                setError(context, name, 'This field is required');
            } else if (isRequired && value.toString().length > 0) {
                setError(context, name, '');
            }
        }
    }
    return status;
}